<template>
  <div>
    <banner-component
        title="Guides sur la facturation électronique, les devis et les factures"
        :lead="lead"
        :breadcrumbs="breadcrumbs"
        ruled/>

    <section class="band" aria-labelledby="list-title">
      <div class="container">
        <h2 id="list-title" class="visually-hidden">Tous les guides</h2>
        <article-list :articles="articles"/>
        <p class="notice">
          Les règles de facturation évoluent. Chaque guide indique sa date de mise à jour et cite ses sources.
          Pour une situation particulière, rapprochez-vous de votre expert-comptable.
        </p>
      </div>
    </section>

    <call-to-action-component/>
  </div>
</template>

<script>
  import articles from "@/content/articles";
  import pages from "@/content/pages";
  import {inline} from "@/seo/inline";
  import {useSeo} from "@/seo/useSeo";
  import {organization, website, webPage, breadcrumb, absoluteUrl} from "@/seo/schema";
  import BannerComponent from "@/components/BannerComponent.vue";
  import ArticleList from "@/components/ArticleList.vue";
  import CallToActionComponent from "@/components/CallToActionComponent.vue";

  const PATH = '/blog';

  const BREADCRUMBS = [
    {name: 'Accueil', path: '/'},
    {name: 'Blog', path: PATH}
  ];

  export default {
    name: 'ArticlesView',
    components: {BannerComponent, ArticleList, CallToActionComponent},
    setup() {
      const page = pages.find(entry => entry.path === PATH);
      useSeo({
        path: PATH,
        graph: [
          organization(),
          website(),
          webPage(PATH, page.title, page.description, {
            '@type': 'CollectionPage',
            breadcrumb: {'@id': `${absoluteUrl(PATH)}#breadcrumb`},
            mainEntity: {
              '@type': 'ItemList',
              itemListElement: articles.map((article, index) => ({
                '@type': 'ListItem',
                position: index + 1,
                url: absoluteUrl(article.path),
                name: article.h1
              }))
            }
          }),
          {...breadcrumb(BREADCRUMBS), '@id': `${absoluteUrl(PATH)}#breadcrumb`}
        ]
      });
    },
    data: function () {
      return {
        articles,
        breadcrumbs: BREADCRUMBS,
        lead: inline('Des guides pratiques pour les **TPE et les indépendants**, rédigés à partir des sources officielles : service-public.fr, impots.gouv.fr et economie.gouv.fr.'),
      }
    }
  }
</script>

<style lang="stylus" scoped>
@import '~/src/common/style/constants.styl';

.notice
  margin 32px 0 0
  max-width 70ch
  color MUTED
  font-size 0.95rem
</style>
